// Settings.js
import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { Button, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import ModelButton from "../../components/ModelButton/ModelButton";
import "./Settings.css";
import DefaultLoader from "../../components/DefaultLoader/DefaultLoader";
import PhoneInput from "../../components/PhoneInput/PhoneInput";

const Settings = () => {
	const { toggleMode, changeAccentColor, mode, accentColor } = useContext(ThemeContext);

	return (
		<div style={{ padding: "10px 15px" }}>
			{/* Toggle Light/Dark Mode */}
			<Button onClick={toggleMode} variant="contained" style={{ margin: "10px 0" }}>
				Toggle to {mode === "light" ? "Dark" : "Light"} Mode
			</Button>

			{/* Accent Color Selection */}
			<Typography variant="subtitle1">Select Accent Color</Typography>
			<ToggleButtonGroup
				value={accentColor}
				exclusive
				onChange={(e, newColor) => changeAccentColor(newColor)}
				aria-label="accent color">
				<ToggleButton value="blue" aria-label="blue">
					Blue
				</ToggleButton>
				<ToggleButton value="red" aria-label="red">
					Red
				</ToggleButton>
				<ToggleButton value="orange" aria-label="orange">
					Orange
				</ToggleButton>
				<ToggleButton value="cyan" aria-label="cyan">
					Cyan
				</ToggleButton>
			</ToggleButtonGroup>
		</div>
	);
};

export default Settings;
